import {assertAndContinue} from 'Asserts';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import {SpreadsheetStorePayload} from 'notebook/tables/spreadsheets/SpreadsheetStore';
import {TypedValue, TableCellEditorPosition} from 'notebook/tables/TableConstants';

export function setFormula({
  tableNamespace,
  tableName,
  fileId,
  documentName,
  index,
  formula,
  typedValue,
  editing,
  selection,
  cellInsertMode,
}: SpreadsheetStorePayload): void {
  // Make sure we didn't forget typedValue.
  // To clear typedValue, you can pass in `null`.
  assertAndContinue(typedValue !== undefined, 'typedValue is required');

  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_FORMULA,
    tableNamespace,
    tableName,
    fileId,
    documentName,
    index,
    formula,
    typedValue,
    editing,
    selection,
    cellInsertMode,
  } satisfies SpreadsheetStorePayload & {actionType: typeof EventConstants.SPREADSHEET_SET_FORMULA});
}

export function setTypedValue(typedValue: TypedValue | null): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_TYPED_VALUE,
    typedValue,
  });
}

export function setCellEditorPosition(cellEditorPosition: TableCellEditorPosition | null): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_CELL_EDITOR_POSITION,
    cellEditorPosition,
  });
}
